//@flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { words } from 'lodash';
import { Banner } from 'components/atoms/banner';
import { useViewport } from 'components/templates/viewportProvider';
import { HTMLView } from 'components/atoms/htmlView';
import { StringUtil } from 'utils/StringUtil';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
import { PROJECT_FILE_DOWNLOAD_URL } from 'config/env';
// eslint-disable-next-line
import styles from "./style.scss";

type Props = {
  theme: string,
  fullpageApi: Object,
};

const ProjectDetailsBanner = (props: Props) => {
  const { height, isMobile } = useViewport();
  if (!props) {
    return null;
  }
  const {
    project,
    media_path,
    web,
    mobile,
    thumbnail,
  } = props.data.projectDetails;

  const location = project.descriptive_area;
  let image = project && `${media_path}${web}/${project.image}`;
  let thumbNail = project && `${media_path}${thumbnail}/${project.image}`;
  const title = project && project.title;
  const project_name=project && project.project_name;
  const mobile_description = project && project.short_description;
  const description=project && project.description
  let className = 'project-details-banner';
  if (isMobile) {
    image = project && `${media_path}${mobile}/${project.mobile_image}`;
    thumbNail = project && `${media_path}${thumbnail}/${project.mobile_image}`;
  }

  let countLengthOf = StringUtil.sliceHtml(project.description);
  const length = words(countLengthOf).length;

  const renderFullDescription = () => {
    return (
      <HTMLView
        className={'project-banner-description'}
        html={description}
        tagName={'p'}
      />
    );
  };

  const animationClasses = ['animate-height', 'animate-width'];

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        imageUrl={image}
        title={project_name}
        thumbNailUrl={thumbNail}
        containerClassName={'banner-intro'}
        descriptionClass={'project-detail-banner-description'}
        description={renderFullDescription()}
        titleHeading={location}
        bannerText={'project-title'}
        bannerImage={animationClasses.join(' ')}
        length={length}
        altImageName={title}
      />
      {isMobile && (
        <HTMLView
          className={'project-banner-description-mobile'}
          html={mobile_description}
          tagName={'h3'}
        />
      )}
      {project.banner_video && (
        <BannerVideoButton videoUrl={project.banner_video} />
      )}
      {/*{isMobile && <FooterExploreButton sectionName={'gallery'} />}*/}
    </div>
  );
};

export default withRouter(ProjectDetailsBanner);
